import { MAIN_SITE, BUSINESS_SITE_URL } from "constants/index";

const MY_PROFILE = "/my-profile";
export const PAGES = {
  MANAGE_USERS: "/manage-users",
  UPGRADE: "/team-upgrade",
  PROFILE_SETUP: `${MAIN_SITE}/onboarding`,
  RESET_PASSWORD: "/auth/reset-password",
  SIGN_IN: `${MAIN_SITE}/login`,
  LOGOUT: "/auth/logout",
  MY_PROFILE,
  EDIT_CARD_DETAILS: `${MY_PROFILE}/edit-card-details`,
  CONTACT_DETAILS: `${MY_PROFILE}/connection-list/`,
  INSTANT_FOLLOWUP_EMAIL: `${MY_PROFILE}/instant-followup-email`,
  SHOP: `${MAIN_SITE}/shop`,
};

export const UPGRADE_PAGES = {
  SELECT_YOUR_PLAN: `${PAGES.UPGRADE}/select-your-plan`,
};

const PROFILE_TEMPLATES = "/profile-templates";
export const PROFILE_TEMPLATE_PAGES = {
  LIST: PROFILE_TEMPLATES,
  CREATE: `${PROFILE_TEMPLATES}/create/:tab?`,
  EDIT: `${PROFILE_TEMPLATES}/:id/edit/:tab?`,
};

export const getTemplateCreateBasePath = () => `${PROFILE_TEMPLATES}/create`;

export const getTemplateEditBasePath = (id: number | string) =>
  `${PROFILE_TEMPLATES}/${id}/edit`;

export const getTemplateCreatePath = (tab = "design") =>
  `${getTemplateCreateBasePath()}/${tab}`;

export const getTemplateEditPath = (id: number | string, tab = "design") =>
  `${getTemplateEditBasePath(id)}/${tab}`;

export const CHECKOUT_URL = {
  SUCCESS: `${BUSINESS_SITE_URL}${PAGES.MANAGE_USERS}`,
  CANCEL: `${BUSINESS_SITE_URL}${PAGES.MANAGE_USERS}`,
};
